import { Trash2, MailOpen, UserRound } from "lucide-react";
import { toast } from "sonner";
import api from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";

function formatDate(iso) {
  if (!iso) return "";
  try {
    return new Date(iso).toLocaleDateString("es-ES", {
      day: "2-digit",
      month: "short",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  } catch {
    return iso;
  }
}

export default function PrayerManager({ requests, reload }) {
  const markRead = async (id) => {
    try {
      await api.put(`/prayer-requests/${id}/read`);
      reload();
    } catch (e) {
      toast.error("No se pudo actualizar");
    }
  };

  const remove = async (id) => {
    try {
      await api.delete(`/prayer-requests/${id}`);
      toast.success("Petición eliminada");
      reload();
    } catch (e) {
      toast.error("No se pudo eliminar");
    }
  };

  return (
    <div data-testid="prayer-manager">
      <div className="mb-6 flex items-center justify-between">
        <h2 className="font-serif text-3xl">Peticiones de Oración</h2>
        <Badge className="border-0 bg-primary/15 text-primary" data-testid="prayer-count">
          {requests.length} recibidas
        </Badge>
      </div>

      {requests.length === 0 ? (
        <Card className="border-dashed border-border bg-card p-16 text-center text-muted-foreground">
          Aún no hay peticiones de oración. Las que envíen desde la página aparecerán aquí.
        </Card>
      ) : (
        <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
          {requests.map((r) => (
            <Card
              key={r.id}
              data-testid={`prayer-card-${r.id}`}
              className={`border-border bg-card p-6 transition-colors ${r.read ? "opacity-70" : "border-primary/40"}`}
            >
              <div className="flex items-start justify-between gap-4">
                <div className="flex items-center gap-2 text-sm font-medium text-primary">
                  <UserRound className="h-4 w-4" />
                  {r.name ? r.name : "Anónimo"}
                  {!r.read && (
                    <Badge className="ml-1 border-0 bg-[hsl(145_55%_45%)]/15 text-[hsl(145_55%_55%)]">Nuevo</Badge>
                  )}
                </div>
                <span className="text-xs text-muted-foreground">{formatDate(r.created_at)}</span>
              </div>

              <p className="mt-4 whitespace-pre-wrap text-sm text-foreground/90">{r.message}</p>

              <div className="mt-5 flex items-center gap-3 border-t border-border pt-4">
                {!r.read && (
                  <Button
                    variant="ghost"
                    size="sm"
                    onClick={() => markRead(r.id)}
                    data-testid={`mark-read-${r.id}`}
                    className="text-muted-foreground hover:text-primary"
                  >
                    <MailOpen className="mr-2 h-4 w-4" /> Marcar como leída
                  </Button>
                )}
                <button
                  onClick={() => remove(r.id)}
                  data-testid={`delete-prayer-${r.id}`}
                  className="ml-auto text-muted-foreground transition-colors hover:text-destructive"
                >
                  <Trash2 className="h-4 w-4" />
                </button>
              </div>
            </Card>
          ))}
        </div>
      )}
    </div>
  );
}
